import React, { Component } from 'react';

class Answer extends Component {
	constructor(props) {
		super(props);
		this.selectAnswer = this.selectAnswer.bind(this);
	}

	selectAnswer() {
		const { callback, answer } = this.props;
		callback(answer);
	}

	render() {
		const { answer, index, givenAnswer } = this.props;
		const isSelected = givenAnswer && givenAnswer.text === answer.text;

		return (
			<button
				onClick={this.selectAnswer}
				data-selected={isSelected}
				className="tech-check-answer-container"
			>
				<span className="tech-check-answer-index">{index}</span>
				<span className="tech-check-answer-text">{answer.text}</span>
			</button>
		);
	}
}

export default Answer;



// WEBPACK FOOTER //
// ./src/components/tech-check/Answer.js